import { datadogRum } from '@datadog/browser-rum';
import { type FC, type ReactNode } from 'react';
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';

interface Props {
  readonly children: ReactNode;
}

const Fallback: FC<FallbackProps> = () => (
  <section className='section is-large'>
    <header className='title'>
      <p className='title'>Uh, oh…</p>
      <p className='subtitle'>Application Error</p>
    </header>
    <main>
      <p>Please contact the administrator for additional assistance.</p>
    </main>
  </section>
);

export const DatadogErrorBoundary: FC<Props> = ({ children }) => (
  <ErrorBoundary
    FallbackComponent={Fallback}
    onError={(error, info) => {
      datadogRum.addError(error, info);
    }}
  >
    {children}
  </ErrorBoundary>
);
DatadogErrorBoundary.displayName = 'DatadogErrorBoundary';
